var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightArrowIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 19,
    viewBox: "0 0 29 19",
    fill: "#0F5BF1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4796 18.7403C16.3791 18.7403 16.2786 18.7171 16.1883 18.6707C15.9614 18.5598 15.8196 18.3329 15.8196 18.0803V12.8003H1.29965C0.936133 12.8003 0.639648 12.5064 0.639648 12.1403V6.86027C0.639648 6.49676 0.936133 6.20027 1.29965 6.20027H15.8196V0.920271C15.8196 0.670193 15.9614 0.44074 16.1883 0.32988C16.4126 0.219021 16.6807 0.244803 16.8818 0.396912L28.1018 8.97691C28.2643 9.10066 28.3596 9.29402 28.3596 9.50027C28.3596 9.70652 28.2643 9.89988 28.0993 10.0236L16.8793 18.6036C16.7632 18.6939 16.6214 18.7403 16.4796 18.7403Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowIcon);
export default __webpack_public_path__ + "static/media/RightArrowIcon.d42f268c5a7e1605079767b2f59ef843.svg";
export { ForwardRef as ReactComponent };